import { useState, useEffect } from "react";
import Api from "../api/api";
import { Modal, Popover, OverlayTrigger } from "react-bootstrap";
import Enums from "../../utilities/enum";
import { AllSitesSummaries } from "./allSitesSummaries";
import stringHelpers from "../../utilities/stringHelpers";
import roleUtilities from "../../utilities/roleUtilities";
import { ErrorModal } from "../../utilities/errorModal";
import { saveAs } from 'file-saver';
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import Loader from "../shared/loader";
import {SuccessModal} from "../shared/successModal";
import {WarningModal} from "../shared/warningModal";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import arrayUtilities from "../../utilities/arrayUtilities";
import { AppliedFilterPill, TagFilterItemLabel } from "../shared/appliedFilterPill";
import appliedFiltersUtilities from "../../utilities/appliedFiltersUtilities";
import { EnforcementDashboardFiltersModal } from "./enforcementDashboardFiltersModal";
import { toDateString } from "../../utilities/dateUtilities";
import { SearchBarWithDebounce } from "../shared/searchBarWithDebounce";
import { FiltersModalTrigger } from "../shared/filtersModalTrigger";
function EnforcementDashboard(props) {
	const location = useLocation()
	const isThirdPartyUser = roleUtilities.isThirdPartyProcessor(props.user, props.organisationId) || roleUtilities.isThirdPartyManager(props.user, props.organisationId)
	const [showFiltersModal, setShowFiltersModal] = useState(false)
	const [searchQuery, setSearchQuery] = useState("");
	const [filterEnd, setFilterEnd] = useState(location && location.state !== undefined && location.state.toDate !== undefined ? location.state.toDate : null);
	const [filterStart, setFilterStart] = useState(location && location.state !== undefined && location.state.fromDate !== undefined ? location.state.fromDate : null);
	const [type, setType] = useState(null);
	const [isOnHold, setIsOnHold] = useState(null);
	const [statuses, setStatuses] = useState(location && location.state !== undefined && location.state.status !== undefined ? [String(location.state.status)] : []);
	const [previousStatuses, setPreviousStatuses] = useState([])
	const [selectedTags, setSelectedTags] = useState([])

	const [sites, setSites] = useState(null);
	const [contraventions, setContraventions] = useState([]);
	const [contravention, setContravention] = useState(null);
	const [excludeVoided, setExcludeVoided] = useState(true)
	const [siteSummaries, setSiteSummaries] = useState([]);
	const [siteIdForExport, setSiteIdForExport] = useState(null)
    const [canRedo, setCanRedo] = useState(false)
	const [showRedoModal, setShowRedoModal] = useState(false);
    const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
	const [multiSelectList, setMultiSelectList] = useState([])
	const [errorMessage, setErrorMessage] = useState(null)
	const [isRedoing, setIsRedoing] = useState(false)
	const [isLoadingSummaries, setIsLoadingSummaries] = useState(false)
	const [firstPageLoad, setFirstPageLoad] = useState(true)
	const [showExportModal, setShowExportModal] = useState(false);
	const [exportType, setExportType] = useState(0)
	const [showVoidModal, setShowVoidModal] = useState(false);
	const [note, setNote] = useState("");
	const [voidErrorMessage, setVoidErrorMessage] = useState(null)
	const [voidSuccessMessage, setVoidSuccessMessage] = useState(null)
	const [voidWarningMessage, setVoidWarningMessage] = useState(null)
    const [voidReasons, setVoidReasons] = useState(null)
    const [voidReason, setVoidReason] = useState("")
	const [showFilterPills, setShowFilterPills] = useState(false)
	const [showChangeStatus, setShowChangeStatus] = useState(false);
	const [canSendToDebtRecovery, setCanSendToDebtRecovery] = useState(false)
	const [appliedFilters, setAppliedFilters] = useState(null)

	const clearFilters = function () {
		setStatuses([]);
		setPreviousStatuses([]);
		setType(null);
		setFilterEnd(null);
		setFilterStart(null);
		setIsOnHold(null)
		setContravention("")
		setExcludeVoided(false)
		setSelectedTags([])
		getSitesSummaries(searchQuery, null, null, null, [], [], null, null, false, [])
		setAppliedFilters(null)
	};

	const getContraventions = function () {
		Api.getContraventions(
			(data) => setContraventions(data),
			(error) => console.log(error),
			props.organisationId,
			props.token
		)
	}

	const getSitesSummaries = (queryString, start, end, contraventionType, breachStatuses, previousBreachStatuses, contravention, onHold, excludeVoids, tagIds) => {
		setIsLoadingSummaries(true)
		Api.getAllSitesSummaries(
			data => {
				setSiteSummaries(data);
				setCanRedo(false)
				setMultiSelectList([])
				setIsSelectAllChecked(false)
				setIsLoadingSummaries(false)
				setFirstPageLoad(false)
			},
			() => {setIsLoadingSummaries(false); setFirstPageLoad(false)},
			stringHelpers.isNullOrEmpty(queryString) ? null : queryString,
			start,
			end,
			!stringHelpers.isNullOrEmpty(contraventionType) ? Number(contraventionType) : null,
			!arrayUtilities.isNullOrEmpty(breachStatuses) ? breachStatuses.map(item => Number(item)) : null,
			!arrayUtilities.isNullOrEmpty(previousBreachStatuses) ? previousBreachStatuses.map(item => Number(item)) : null,
			onHold,
			null,
			!stringHelpers.isNullOrEmpty(contravention) ? contravention : null,
			excludeVoids ? [503] : null,
			tagIds,
			props.organisationId,
			props.token
		);
	};

	const getSites = function () {
		Api.getSites(
			(data) => setSites(data),
			(error) => console.log(error),
			props.organisationId,
			props.token
		);
	};

	useEffect(() => {
		getSitesSummaries(searchQuery, filterStart, filterEnd, type, statuses, previousStatuses, contravention, isOnHold, excludeVoided, selectedTags);
	}, [])

	const getVoidReasons = () => {
		Api.getVoidReasons(
			(data) => setVoidReasons(data),
			(error) => console.log(error),
			props.organisationId,
			props.token
		)
	}

	useEffect(() => {
		getSites();
		getVoidReasons()
		getContraventions()
		if (excludeVoided) {
			setAppliedFilters(prevState => {
				const updatedFilters = { ...prevState }
				updatedFilters["Voids"] = "Excluded"
				return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
			})
			setShowFilterPills(true)
		}
		if (!arrayUtilities.isNullOrEmpty(statuses)) {
			setAppliedFilters(prevState => {
				const updatedFilters = { ...prevState }
				updatedFilters["Status"] = statuses.length > 1 ? statuses.map(status => ({ id: status, name: Enums.BreachStatus[status] })) : Enums.BreachStatus[statuses[0]]
				return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
			})
			setShowFilterPills(true)
		}
		if (filterStart !== null && filterEnd !== null) {
			setAppliedFilters(prevState => {
				const updatedFilters = { ...prevState }
				updatedFilters["Date Range"] = `${toDateString(new Date(filterStart))} - ${toDateString(new Date(filterEnd))}`
				return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
			})
			setShowFilterPills(true)
		}
		else if (filterStart !== null) {
			setAppliedFilters(prevState => {
				const updatedFilters = { ...prevState }
				updatedFilters["From"] = toDateString(new Date(filterStart))
				return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
			})
			setShowFilterPills(true)
		}
		else if (filterEnd !== null) {
			setAppliedFilters(prevState => {
				const updatedFilters = { ...prevState }
				updatedFilters["To"] = toDateString(new Date(filterEnd))
				return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
			})
			setShowFilterPills(true)
		}
	}, []);

	const exportToCSV = () => {
		Api.getBreaches(
			(blob, filename) => { 
				saveAs(blob, filename); 
				setExportType(0)
				setShowExportModal(false) 
			},
			error => {
				console.log(error)
				setShowExportModal(false)
			},
			stringHelpers.isNullOrEmpty(searchQuery) ? null : searchQuery, (exportType === 0 && !stringHelpers.isNullOrEmpty(siteIdForExport)) ? [siteIdForExport] : null, null, null, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(type) ? Number(type) : null, !arrayUtilities.isNullOrEmpty(statuses) ? statuses.map(item => Number(item)) : null, isOnHold, 0, 1, !stringHelpers.isNullOrEmpty(contravention) ? contravention : null, excludeVoided ? [503] : null, !arrayUtilities.isNullOrEmpty(previousStatuses) ? previousStatuses.map(item => Number(item)) : null, null, null, selectedTags, props.organisationId, props.token
		)
	}

	const handleMultiVoidConfirm = () => {
		setShowVoidModal(false);
		Api.voidMultipleTickets(
			data => {
				if (data.isError) {
					setVoidErrorMessage(data.errorMessage)
				}
				else {
					if (data.length > 0) {
                        setVoidSuccessMessage(`${data.length } ${data.length > 1 ? "breaches" : "breach"} voided successfully`)
                    } else {
                        setVoidWarningMessage("No breach were updated")
                    }
					getSitesSummaries(searchQuery, filterStart, filterEnd, type, statuses, previousStatuses, contravention, isOnHold, excludeVoided, selectedTags)
					setMultiSelectList([]);
					setVoidReason("");
					setNote("");
				}
			},
			error => {
				console.log(error)
				setVoidErrorMessage(error.errorMessage)
			},
			multiSelectList, !stringHelpers.isNullOrEmpty(voidReason) ? voidReason : null, !stringHelpers.isNullOrEmpty(note) ? note : "ticket voided", props.organisationId, props.token)
	}

	const handleRemoveAndRedo = () => {
		setIsRedoing(true)
		setShowRedoModal(false)
		Api.deleteBreaches(
			props.organisationId, multiSelectList,
			data => {
				if (data.isError) {
					setIsRedoing(false)
					setErrorMessage(data.errorMessage)
				}
				else {
					setIsRedoing(false)
					setErrorMessage(null)
					getSitesSummaries(searchQuery, filterStart, filterEnd, type, statuses, previousStatuses, contravention, isOnHold, excludeVoided, selectedTags);
					setCanRedo(false)
					setMultiSelectList([])
					setIsSelectAllChecked(false)
				}
			},
			error => {
				setErrorMessage(error.message)
				setIsRedoing(false)
			},
			props.token
		)
	}

	const breachStatusOptionsByRole = () => {
		const allOptions = Object.entries(Enums.BreachStatus)
		const options = (isThirdPartyUser || roleUtilities.isOrganisationProcessor(props.user, props.organisationId))
			? allOptions
				.filter(([key]) => (key !== "0"))
			: allOptions

		return [{value: "", label: "All"}, ...options.map(([key, value]) => ({value: key, label: value}))]
	}

	const clearFilterByLabel = (label) => {
		switch (label) {
			case "Type":
				setType(null)
				getSitesSummaries(searchQuery, filterStart, filterEnd, null, statuses, previousStatuses, contravention, isOnHold, excludeVoided, selectedTags);
				break
			case "Status":
				setStatuses([])
				getSitesSummaries(searchQuery, filterStart, filterEnd, type, null, previousStatuses, contravention, isOnHold, excludeVoided, selectedTags);
				break
			case "Previous Status":
				setPreviousStatuses([])
				getSitesSummaries(searchQuery, filterStart, filterEnd, type, statuses, null, contravention, isOnHold, excludeVoided, selectedTags);
				break
			case "Contravention":
				setContravention("")
				getSitesSummaries(searchQuery, filterStart, filterEnd, type, statuses, previousStatuses, null, isOnHold, excludeVoided, selectedTags);
				break
			case "On Hold":
				setIsOnHold(null)
				getSitesSummaries(searchQuery, filterStart, filterEnd, type, statuses, previousStatuses, contravention, null, excludeVoided, selectedTags);
				break
			case "Voids":
				setExcludeVoided(false)
				getSitesSummaries(searchQuery, filterStart, filterEnd, type, statuses, previousStatuses, contravention, isOnHold, false, selectedTags);
				break
			case "From":
				setFilterStart(null)
				getSitesSummaries(searchQuery, null, filterEnd, type, statuses, previousStatuses, contravention, isOnHold, excludeVoided, selectedTags);
				break;
			case "To":
				setFilterEnd(null)
				getSitesSummaries(searchQuery, filterStart, null, type, statuses, previousStatuses, contravention, isOnHold, excludeVoided, selectedTags);
				break;
			case "Date Range":
				setFilterStart(null)
				setFilterEnd(null)
				getSitesSummaries(searchQuery, null, null, type, statuses, previousStatuses, contravention, isOnHold, excludeVoided, selectedTags);
				break
			case "Tags":
				setSelectedTags([])
				getSitesSummaries(searchQuery, filterStart, filterEnd, type, statuses, previousStatuses, contravention, isOnHold, excludeVoided, []);
				break
			default:
				break
		}
	}

	const removeMultiSelectFilterItemByLabel = (label, remainingIds) => {
		switch (label) {
			case "Tags":
				setSelectedTags(remainingIds)
				getSitesSummaries(searchQuery, filterStart, filterEnd, type, statuses, previousStatuses, contravention, isOnHold, excludeVoided, remainingIds);
				break
			case "Status":
				setStatuses(remainingIds)
				getSitesSummaries(searchQuery, filterStart, filterEnd, type, remainingIds, previousStatuses, contravention, isOnHold, excludeVoided, selectedTags);
				break
			case "Previous Status":
				setPreviousStatuses(remainingIds)
				getSitesSummaries(searchQuery, filterStart, filterEnd, type, statuses, remainingIds, contravention, isOnHold, excludeVoided, selectedTags);
				break
			default:
				break
		}
	}

	const renderMultiSelectFilterItemLabel = (label, item) => {
		switch (label) {
			case "Tags":
				return <TagFilterItemLabel tag={ item } />
			default:
				return <p className="m-0">{ item.name }</p>
		}
	}

	const handleFilterPillClose = closedLabel => {
		clearFilterByLabel(closedLabel)
		setAppliedFilters(prevState => {
			const updatedFilters = { ...prevState }
			if (closedLabel === "From" || closedLabel === "To" || closedLabel === "Date Range") {
				updatedFilters.From = null
				updatedFilters.To = null
				updatedFilters["Date Range"] = null
			} else {
				updatedFilters[closedLabel] = null
			}
			return appliedFiltersUtilities.hasRemainingFilters(updatedFilters) ? updatedFilters : null
		})
	}

	const handleFilterPillItemRemove = (label, remainingIds) => {
		setAppliedFilters(prevState => appliedFiltersUtilities.keepMultiSelectionItems(prevState, label, remainingIds))
		removeMultiSelectFilterItemByLabel(label, remainingIds)
	}

	const renderBreachCount = (siteId) => {
		let count;
		if (stringHelpers.isNullOrEmpty(siteId)) {
			count = siteSummaries.reduce(
				(acc, curr) => {
					return acc += curr.count
				}, 0
			)
		} else {
			const siteSummary = siteSummaries.find(summary => summary.siteId === siteId)
			if (siteSummary !== undefined) {
				count = siteSummary.count
			}
		}
		return `${ stringHelpers.formatDecimal(count, 0)} ${count === 1 ? "breach" : "breaches"}`
	}

	return (
		<div className="container-fluid">
			<div className="bg-white p-3">
				<div className="d-flex justify-content-between align-items-center">
					<h5 className="fs-0 m-0 text-nowrap py-2 py-xl-0">
							Enforcement
						</h5>
					<div className="d-flex align-items-center">
						<div className="d-flex align-items-center">
							<div className="mr-2">
								<SearchBarWithDebounce onSearchQueryChange={ query => {
								setSearchQuery(query)
								getSitesSummaries(query, filterStart, filterEnd, type, statuses, previousStatuses, contravention, isOnHold, excludeVoided, selectedTags)
							} } />
							</div>
							<div className="mr-2">
								<FiltersModalTrigger onClick={ () => setShowFiltersModal(true) } />
							</div>
						</div>
						<div className={`d-flex ${(!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId)) ? "border-right pr-2" : ""}`}>
							<button className="btn btn-primary btn-sm nowrap" onClick={() => setShowExportModal(true)} disabled={isLoadingSummaries ? "disabled" : ""}>Export</button>
							{
								roleUtilities.isOrganisationAdmin(props.user, props.organisationId) && !isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) &&
								<OverlayTrigger trigger="hover" placement='left' overlay={<Popover className='redo-popover'><p className='m-0 p-2'>Remove the breach and reset the parking sessions so they can be re-processed in the next batch tomorrow morning</p></Popover>}>
									<div className='d-flex align-items-center'>
										<button
											disabled={!canRedo}
											className="btn btn-primary btn-sm col-auto ml-2 text-nowrap"
											onClick={() => setShowRedoModal(true)}>
											<i className="fas fa-undo"></i> Remove and re-do
										</button>
									</div>
								</OverlayTrigger>}
						</div>
						{!roleUtilities.isThirdPartyProcessor(props.user, props.organisationId) && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) &&
							<button
								disabled={ arrayUtilities.isNullOrEmpty(multiSelectList) }
								className="btn btn-danger btn-sm text-nowrap"
								onClick={ () => setShowVoidModal(true) }>
								<i className="fas fa-times"></i> Void
							</button>}


						<button disabled={!canSendToDebtRecovery} className="btn btn-success btn-sm ml-2" onClick={() =>
						setShowChangeStatus(true)}><i
							className="fas fa-play mr-1"></i>Send to debt recovery
						</button>
						{!isThirdPartyUser && <div className="d-flex align-items-center" style={{paddingLeft: "12px"}}>
								<Link to={{
									pathname: `/organisation/${props.organisationId}/allocate`,
									state: {
										isAssigned: null
									}
								}}>
									<button className="btn btn-falcon-default btn-sm mr-2 text-nowrap">Re-Allocate</button>
								</Link>
								<Link to={{
									pathname: `/organisation/${props.organisationId}/allocate`,
									state: {
										isAssigned: false
									}
								}}>
									<button className="btn btn-falcon-default btn-sm">Allocate</button>
								</Link>
							</div>}
					</div>
				</div>
			</div>
			<div className="d-flex align-items-center mt-3 mb-0">
				{
					showFilterPills && appliedFilters &&
					Object.entries(appliedFilters).map(
						([label, value]) => <AppliedFilterPill
							key={ label }
							label={ label }
							value={ value }
							renderItemLabel={ renderMultiSelectFilterItemLabel }
							onTextClick={ () => setShowFiltersModal(true) }
							onCloseClick={ handleFilterPillClose }
							onRemoveItem={ handleFilterPillItemRemove }
						/>
					)
				}
				{appliedFilters && Object.keys(appliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={() => clearFilters()}>Clear all filters</button>}
			</div>
			<div className="row">
				<div className="col-12 mb-3">
					{ firstPageLoad
					? <div><Loader /></div>
					: (
						<AllSitesSummaries
							isLoadingSummaries={isLoadingSummaries}
							isRedoing={isRedoing}
							statuses={statuses}
							previousStatuses={previousStatuses}
							type={type}
							filterEnd={filterEnd}
							filterStart={filterStart}
							searchQuery={searchQuery}
							isOnHold={isOnHold}
							contraventionId={contravention}
							excludeVoided={excludeVoided}
							tagIds={selectedTags}
							siteSummaries={siteSummaries}
							organisationId={props.organisationId}
							token={props.token}
							onSiteChange={id => setSiteIdForExport(id)}
							setCanRedo={setCanRedo}
							isSelectAllChecked={isSelectAllChecked}
							setIsSelectAllChecked={setIsSelectAllChecked}
							multiSelectList={multiSelectList}
							setMultiSelectList={setMultiSelectList}
							setCanSendToDebtRecovery={setCanSendToDebtRecovery}
						/>
					)}
				</div>
			</div>
			<Modal show={showRedoModal} onHide={() => setShowRedoModal(false)}>
				<Modal.Header>
					<Modal.Title>
						Remove and re-do
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					Are you sure you want to remove and re-do {multiSelectList.length === 1 ? <>this ticket</>: <>these {multiSelectList.length} tickets</>}?
				</Modal.Body>
				<Modal.Footer>
					<button
						className="btn btn-sm btn-danger mt-1"
						onClick={() => setShowRedoModal(false)}
					>
						Cancel
					</button>
					<button
						className="btn btn-sm btn-success mt-1"
						onClick={handleRemoveAndRedo}
					>
						Confirm
					</button>
				</Modal.Footer>
			</Modal>

			{
				sites &&
				<Modal show={ showExportModal } onHide={ () => {
					setShowExportModal(false)
					setExportType(0)
				} }>
					<Modal.Header>
						<Modal.Title>
							Export
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{
							!stringHelpers.isNullOrEmpty(siteIdForExport)
							? <>
								Do you want to export only for <b>{sites.find(item => item.id === siteIdForExport).name}</b>, or all sites?
								<div className="mt-2">
									<div className='d-flex align-items-center'>
										<input className='mb-1' checked={ exportType === 0 } value={ 0 } onClick={ () => setExportType(0) } name="export-data" id="export-by-site" type='radio' />
										<label style={ { fontSize: "1rem" } } className='m-0 ml-2' for="export-by-site">
											Just for {sites.find(item => item.id === siteIdForExport).name} ({renderBreachCount(siteIdForExport)})
										</label>
									</div>
									<div className='d-flex align-items-center'>
										<input className='mb-1' checked={ exportType === 1 } value={ 1 } onClick={ () => setExportType(1) }  name="export-data" id="export-all" type='radio' />
										<label style={ { fontSize: "1rem" } } className='m-0 ml-2' for="export-all">
											All sites ({renderBreachCount(null)})
										</label>
									</div>
								</div>
							</>
							: <>This will export data for all sites ({renderBreachCount(null)}). Are you sure?</>
						}
					</Modal.Body>
					<Modal.Footer>
						<button
							className="btn btn-sm btn-danger mt-1"
							onClick={ () => {
								setShowExportModal(false)
								setExportType(0)
							} }
						>
							Cancel
						</button>
						<button
							className="btn btn-sm btn-success mt-1"
							onClick={ () => exportToCSV() }
						>
							Confirm
						</button>
					</Modal.Footer>
				</Modal>
			}
			{
				showVoidModal && !arrayUtilities.isNullOrEmpty(voidReasons) &&
				<Modal show onHide={ () => { setShowVoidModal(false); setVoidReason(""); setNote("") } }>
					<Modal.Header>
						<Modal.Title>
							Void multiple breaches.
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="row mb-2">
							<div className="col-12 ">
								<p className="font-weight-semi-bold  mt-1 mb-1">Reason:</p>
							</div>
							<div className="col-12">
								<div className="form-group mb-0">
									<select
										id="void-reason-selector"
										className="border rounded py-1 px-2 w-100"
										onChange={ (e) => setVoidReason(e.target.value) }
										value={ voidReason }
									>
										<option value="">Select a reason</option>
										{ voidReasons?.map(item => <option value={ item.id }>{ item.name }</option>) }
									</select>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-12 ">
								<p className="font-weight-semi-bold  mt-1 mb-2">Note:</p>
							</div>
							<div className="col-12">
								<div className="form-group mb-0">
									<textarea className="form-control mb-0" rows={ 4 } value={ note } onChange={ (e) => setNote(e.target.value) } />
								</div>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<button
							className="btn btn-sm btn-danger mt-1"
							onClick={ () => { setShowVoidModal(false); setVoidReason(""); setNote("") } }
						>
							Cancel
						</button>
						<button
							className="btn btn-sm btn-success mt-1"
							onClick={ handleMultiVoidConfirm }
						>
							Confirm
						</button>
					</Modal.Footer>
				</Modal>
			}
			{
				showFiltersModal &&
				<EnforcementDashboardFiltersModal
					showModal={ showFiltersModal }
					handleClose={ () => setShowFiltersModal(false) }
					handleConfirm={ (draftFilters) => {
						setFilterStart(draftFilters.filterStart)
						setFilterEnd(draftFilters.filterEnd)
						setType(draftFilters.type)
						setStatuses(draftFilters.selectedStatuses)
						setPreviousStatuses(draftFilters.selectedPreviousStatuses)
						setContravention(draftFilters.contravention)
						setIsOnHold(draftFilters.isOnHold)
						setExcludeVoided(draftFilters.excludeVoided)
						setSelectedTags(draftFilters.selectedTags)
						setAppliedFilters(draftFilters.appliedFilters)
						setShowFilterPills(true)
						setShowFiltersModal(false)
						getSitesSummaries(searchQuery, draftFilters.filterStart, draftFilters.filterEnd, draftFilters.type, draftFilters.selectedStatuses, draftFilters.selectedPreviousStatuses, draftFilters.contravention, draftFilters.isOnHold, draftFilters.excludeVoided, draftFilters.selectedTags)
					} }
					initialFilterStart={ filterStart }
					initialFilterEnd={ filterEnd }
					initialType={ type }
					initialStatuses={ statuses }
					initialPreviousStatuses={ previousStatuses }
					initialContravention={ contravention }
					initialIsOnHold={ isOnHold }
					initialExcludeVoided={ excludeVoided }
					initialSelectedTags={ selectedTags }
					initialAppliedFilters={ appliedFilters }
					contraventions={ contraventions }
					tags={ props.tags || [] }
					statusOptions={ breachStatusOptionsByRole() }
					key="filters-modal"
				/>
			}
			{
				showChangeStatus &&
				<Modal show onHide={ () => { setShowChangeStatus(false); setNote("") } }>
					<Modal.Header>
						<Modal.Title>Send to debt recovery</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="row">
							<div className="col-12 ">
								<p className="font-weight-semi-bold mb-2">Note:</p>
							</div>
							<div className="col-12">
								<div className="form-group mb-0">
									<textarea className="form-control mb-0" rows={ 4 } value={ note } onChange={ (e) => setNote(e.target.value) } />
								</div>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<button
							className="btn btn-sm btn-danger mt-1"
							onClick={ () => { setShowChangeStatus(false); setNote("") } }
						>
							Cancel
						</button>
						<button
							disabled={stringHelpers.isNullOrEmpty(note)}
							className="btn btn-sm btn-success mt-1"
							onClick={ () => {
								setShowChangeStatus(false)
								setIsLoadingSummaries(true)
								Api.sendMultipleTicketsToDebtRecovery(
									data => {
										if (data.isError) {
											setErrorMessage(data.errorMessage)
											setIsLoadingSummaries(false)
										} else {
											getSitesSummaries(searchQuery, filterStart, filterEnd, type, statuses, previousStatuses, contravention, isOnHold, excludeVoided, selectedTags)
										}
									},
									error => {
										setErrorMessage(error.errorMessage)
										setIsLoadingSummaries(false)
									},
									multiSelectList, note, props.organisationId, props.token
								)
							} }
						>
							Confirm
						</button>
					</Modal.Footer>
				</Modal>

			}
			{!stringHelpers.isNullOrEmpty(errorMessage) && <ErrorModal key="remove-redo-error" message={errorMessage} onHide={() => setErrorMessage(null)} />}
			{!stringHelpers.isNullOrEmpty(voidErrorMessage) && <ErrorModal key="void-error" message={voidErrorMessage} onHide={() => setVoidErrorMessage(null)} />}
			{!stringHelpers.isNullOrEmpty(voidSuccessMessage) && <SuccessModal message={voidSuccessMessage} onHide={() => setVoidSuccessMessage(null)} />}
			{!stringHelpers.isNullOrEmpty(voidWarningMessage) && <WarningModal message={voidWarningMessage} onHide={() => setVoidWarningMessage(null)} />}
		</div>
	);
}

export default EnforcementDashboard;